"use client"

import type { TrackEventProperties } from "@/modules/tracking/types"
import type { BaseProps, ButtonProps } from "@jobteaser/spark/components/Button/Button"
import type { ComponentWithJsxTagPropsType } from "@jobteaser/spark/types/CustomTagComponent"
import type { FunctionComponent, MouseEventHandler, PropsWithChildren } from "react"

import { Button } from "@jobteaser/spark/components/Button"

import { useTracking } from "@/modules/tracking/useTracking"

type TrackButtonProps<TagType> = ButtonProps<TagType> & PropsWithChildren<{ trackingProps: TrackEventProperties }>

// eslint-disable-next-line react/function-component-definition
export function TrackButton<TagType>({
  children,
  renderComponent,
  trackingProps: { eventName, eventProperties },
  ...props
}: TrackButtonProps<TagType>): ReturnType<FunctionComponent<TrackButtonProps<TagType>>> {
  const tracking = useTracking()

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event): void => {
    tracking?.track(eventName, eventProperties)

    if (
      typeof (props as ComponentWithJsxTagPropsType<BaseProps<typeof renderComponent>, "button">).onClick !==
      "undefined"
    ) {
      ;(props as ComponentWithJsxTagPropsType<BaseProps<typeof renderComponent>, "button">).onClick?.(event)
    }
  }

  return (
    <Button {...props} renderComponent={renderComponent as unknown} onClick={handleClick}>
      {children}
    </Button>
  )
}
